import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { NotFoundIcon, StandbySensorFoundIcon } from "@/components/ui/SvgIcon";

import cn from "@/utils/cn";
import { ROUTES } from "@/constants/routes";

type Props = {
  query?: string;
  message?: string;
  className?: string;
  varient?: "notFound" | "notActivated";
};
export const NotFound = ({
  query,
  message = "",
  className,
  varient = "notFound",
}: Props) => {
  return (
    <div
      data-testid="not-found"
      className={cn(
        "flex items-center justify-center text-center text-xxs text-chorus-gray-900",
        className,
      )}
    >
      <div>
        {varient === "notActivated" ? (
          <StandbySensorFoundIcon
            className="mx-auto mb-2 h-24"
            data-testid="standbySensorIcon"
          />
        ) : (
          <NotFoundIcon className="mx-auto mb-2" data-testid="notFoundIcon" />
        )}

        <span className="mb-0.5 block font-sora text-md font-superRegular tracking-[-0.02em] text-chorus-black-100">
          {varient === "notFound" ? (
            <FormattedMessage
              defaultMessage="Nothing Found"
              description="Message displayed when no results are found"
            />
          ) : (
            <FormattedMessage
              defaultMessage="Sensor Not Activated"
              description="Message displayed when a sensor is not activated"
            />
          )}
        </span>
        {query ? (
          varient === "notFound" ? (
            <p
              data-testid="not-found-text"
              className="text-[13px] [&_strong]:font-medium [&_strong]:text-chorus-black-100"
            >
              <FormattedMessage
                defaultMessage="No matches for “{query}”"
                description="Message displayed when no results are found for a specific query"
                values={{ query: <strong>{query}</strong> }}
              />
            </p>
          ) : (
            <div
              data-testid="not-found-text"
              className="text-[13px] [&_strong]:font-medium [&_strong]:text-chorus-black-100"
            >
              <div className="mx-6 text-sm text-chorus-gray-900">
                <FormattedMessage
                  defaultMessage="There are no recorded measures for sensor {query}. Please activate the sensor and place it near a reader."
                  description="Message displayed when a sensor is not activated"
                  values={{
                    query: <span className="font-semibold">{query}</span>,
                  }}
                />
                <br />
                <Link
                  to={ROUTES.STANDBY_SENSORS}
                  className="text-chorus-teal-600"
                >
                  <FormattedMessage
                    defaultMessage="View Standby Sensors."
                    description="Link text for seeing standby sensors tab."
                  />
                </Link>
              </div>
            </div>
          )
        ) : (
          <p
            data-testid="not-found-text"
            className="text-[13px] [&_strong]:font-medium [&_strong]:text-chorus-black-100"
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};
